
import Vue from "vue";
import { ProductGroup } from "@/models/base/product-group";

export default Vue.extend({
	name: "AppGroup",
	props: {
		value: {
			type: Object as ()=> ProductGroup,
			required: true
		},
		activeGroupId: Number
	},
	methods: {
		activate(group:ProductGroup){
			this.$emit("activate",group);
		}
	},
	components: {

	}
});
